import React, { FunctionComponent } from 'react';
import { Container } from 'reactstrap';

const ViewContainer: FunctionComponent = ({ children, ...props }) => (
    <Container fluid className="animated fadeIn mt-4" {...props}>{children}</Container>
);

export default ViewContainer;